import React from 'react'
const RouterContexttext = React.createContext({})
export const ThingsProvider = RouterContexttext.Provider
export default RouterContexttext